var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2909 10.5424C16.6815 10.1519 17.3146 10.1519 17.7052 10.5424L22.2052 15.0424C22.5957 15.4329 22.5957 16.0661 22.2052 16.4566L17.7052 20.9566C17.3146 21.3471 16.6815 21.3471 16.2909 20.9566C15.9004 20.5661 15.9004 19.9329 16.2909 19.5424L20.0838 15.7495L16.2909 11.9566C15.9004 11.5661 15.9004 10.9329 16.2909 10.5424Z",
    fill: "#1650FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32863 6.08009C5.50073 4.90799 7.09044 4.24951 8.74805 4.24951H16.998C17.5503 4.24951 17.998 4.69723 17.998 5.24951C17.998 5.8018 17.5503 6.24951 16.998 6.24951H8.74805C7.62088 6.24951 6.53987 6.69728 5.74284 7.49431C4.94581 8.29134 4.49805 9.37234 4.49805 10.4995C4.49805 11.6267 4.94581 12.7077 5.74284 13.5047C6.53987 14.3017 7.62088 14.7495 8.74805 14.7495H21.498C22.0503 14.7495 22.498 15.1972 22.498 15.7495C22.498 16.3018 22.0503 16.7495 21.498 16.7495H8.74805C7.09044 16.7495 5.50073 16.091 4.32863 14.9189C3.15653 13.7468 2.49805 12.1571 2.49805 10.4995C2.49805 8.84191 3.15653 7.2522 4.32863 6.08009Z",
    fill: "#1650FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.e5ab376161e4cbfa9fb0bbdd8833c813.svg";
export { ForwardRef as ReactComponent };